var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"popWarp",on:{"click":function($event){return _vm.closePop()}}},[_c('div',{class:`popDetail ${_vm.$store.state.isMobile ? '' : 'pcPop'}`,on:{"click":function($event){$event.stopPropagation();}}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }